import { Button } from "../../../components/Button/Button";
import "./LeafFilterButton.scss";

type Props = {
  text: string;
  theme?: string;
  active?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  onButtonClick: React.MouseEventHandler<HTMLButtonElement>;
  children?: any;
  addStyleWhenFocussed?: boolean;
  tabIndexData?: { ind: number };
  dataTestId?: string;
};

const LeafFilterButton = (props: Props) => {
  const {
    text,
    onButtonClick,
    theme,
    children,
    active = true,
    disabled = false,
    ariaLabel = "",
    addStyleWhenFocussed,
    tabIndexData,
    dataTestId,
  } = props;

  const themeClass = `leaf-filter-button${theme ? ` ${theme}` : ""}`;
  const activeClass = `${!active ? " leaf-filter-button--not-active" : ""}`;
  const disbaledClass = `${disabled ? " leaf-filter-button--disabled" : ""}`;
  const focussedClass = `${addStyleWhenFocussed ? " leaf-filter-button--focussed" : ""}`;

  return (
    <Button
      disabled={disabled}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      className={`${themeClass}${activeClass}${disbaledClass}${focussedClass}`}
      onClick={onButtonClick}
      tabIndex={tabIndexData ? tabIndexData.ind : undefined}
      data-testid={dataTestId}
    >
      {text}
      {children}
    </Button>
  );
};

export default LeafFilterButton;
